<template>
  <div>
    <p class="cm-mg-p-wzd">3.1 {{ $t('pqr.pqr_info') }}</p>
    <hr />
    <el-form
      :model="model"
      :rules="allRequired ? rulesAll : rules"
      ref="form"
      class="el-form-pqr"
    >
      <div class="row">
        <div class="col-md-6">
          <el-form-item
            class="col-12 is-no-asterisk p-0"
            :label="`${$t('pqr.reason_or_motive')}: *`"
            prop="reason"
          >
            <el-input
              maxlength="500"
              show-word-limit
              v-model="model.reason"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              class="shadow-sm text-center"
            />
          </el-form-item>
          <el-form-item
            class="col-12 is-no-asterisk p-0"
            :label="`${$t('pqr.action_plan')}: ${allRequired ? '*' : ''}`"
            prop="action_plan"
          >
            <el-input
              maxlength="500"
              show-word-limit
              v-model="model.action_plan"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              class="shadow-sm text-center"
            />
          </el-form-item>
          <el-form-item
            class="col-12 is-no-asterisk p-0"
            :label="`${$t('common_words.observation')}: ${
              allRequired ? '*' : ''
            }`"
            prop="observations"
          >
            <el-input
              maxlength="500"
              show-word-limit
              v-model="model.observations"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              class="shadow-sm text-center"
            />
          </el-form-item>
        </div>
        <div class="col-md-6">
          <div class="ml-4">
            <el-form-item>
              <span style="font-size: 16px"
                >{{ $t('common_words.evidence') }}:
              </span>
              <el-upload
                class="el-upload-pqr"
                drag
                multiple
                ref="uploadPqrEvidence"
                :action="getAxiosURL() + '/auth/pqrs/pqrs/uploadEvidence'"
                :data="uploadData"
                :headers="headerInfo"
                :limit="1000"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-exceed="handleExceed"
                :on-success="handleSuccess"
                :file-list="fileList"
                :auto-upload="false"
                :accept="acceptedFilesString"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  {{ $t('common_words.finished_evidence') }}
                  <em>{{ $t('common_words.click_to_load') }}</em>
                </div>
                <div slot="tip" class="el-upload__tip">
                  {{ $t('common_words.file_size_limit_fivemb') }}
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { Form, FormItem } from 'element-ui';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    'el-form': Form,
    'el-form-item': FormItem,
  },

  data() {
    return {
      allRequired: false,
      fileList: [],
      acceptedFilesString:
        'image/jpeg,image/png,image/jpg,.pdf,.xlsx,.docx,.pptx',
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      uploadData: {
        user: this.$store.state.auth.user.id,
        idPqr: null,
      },
      model: {
        reason: null,
        action_plan: null,
        observations: null,
        fileList: [],
      },
    };
  },
  computed: {
    rules() {
      return {
        reason: [
          {
            required: true,
            whitespace: true,
            message: i18n.t('pqr.reason_or_motive_field'),
            trigger: 'blur',
          },
        ],
        action_plan: [
          {
            required: false,
            whitespace: true,
            message: i18n.t('pqr.action_plan_field'),
            trigger: 'blur',
          },
        ],
        observations: [
          {
            required: false,
            whitespace: true,
            message: i18n.t('pqr.observation_field'),
            trigger: 'blur',
          },
        ],
      };
    },
    rulesAll() {
      return {
        reason: [
          {
            required: true,
            whitespace: true,
            message: i18n.t('pqr.reason_or_motive_field'),
            trigger: 'blur',
          },
        ],
        action_plan: [
          {
            required: true,
            whitespace: true,
            message: i18n.t('pqr.action_plan_field'),
            trigger: 'blur',
          },
        ],
        observations: [
          {
            required: true,
            whitespace: true,
            message: i18n.t('pqr.observation_field'),
            trigger: 'blur',
          },
        ],
      };
    },
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],

  methods: {
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },

    validate() {
      return this.$refs['form'].validate().then((response) => {
        this.$emit('on-validated', response, this.model);

        return response;
      });
    },

    handleRemove(_, fileList) {
      this.fileList = fileList;
      this.model.fileList = fileList.map((file) => file.name);
    },

    handleExceed(_, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.common.the_limit')} ${
          this.$refs.uploadPqrEvidence.limit
        },
        ${i18n.t('sweet_alert.common.already_selected')} ${
          fileList.length
        } ${i18n.t('sweet_alert.common.files')}`
      );
    },

    handleSuccess(response) {
      if (response.error) {
        SweetAlert.warning(response.error);
      }
    },

    submitUpload() {
      this.$refs.uploadPqrEvidence.submit();
      this.fileList = [];
    },

    handleChange(file, fileList) {
      const maxSizeInKB = 5000;
      const isSizeValid = file.size / 1024 > maxSizeInKB;
      if (isSizeValid) {
        SweetAlert.warning(i18n.t('sweet_alert.common.maximum_size_per_file'));
        this.$refs.uploadPqrEvidence.uploadFiles.pop();
      }
      this.fileList = fileList;
      this.model.fileList = fileList.map((file) => file.name);
    },
  },
};
</script>
